<template>

    <div class="row" v-if="isAvailableForView">
        <div v-if="loading" class="lds-dual-ring"></div>
        <div class="col-lg-12 mb-4" v-if="!loading">
            <div class="box">
                <div class="box-offset">
                    <div class="box-ttl-wrap">
                        <div class="box-ttl">
                            Uniform articles
                        </div>
                    </div>
                    <div class="buttons--row">
                        <div class="search--block">
                            <button
                                class="search--block-btn"
                                type="submit"
                                @click="getUniformsList"
                            ><img src="/img/svg/icons-search.svg" alt=""></button>
                            <input
                                type="search"
                                class="search--block-txt"
                                v-model="filters.search"
                                @input="handleSearch"
                            />
                        </div>
                        <button class="btn btn--outline-primary btn--middle" @click="showModal">+ Add New</button>

                        <AddNewItemModal
                            title="Add New Uniform"
                            title2="Uniform"
                            id="uniform-modal"
                            confirm-text="Save"
                            reject-text="Cancel"
                            type="input"
                            @confirm="addNewUniform"
                        ></AddNewItemModal>

                    </div>
                    <div class="mt-4">
                        <div class="table-holder table-responsive">
                            <table class="table">
                                <thead>
                                <tr>
                                    <th colspan="2">
                                        <a href="javascript:void(0)" @click.prevent="changeSortList('title')">
                                            Uniform articles
                                            <i class="fas fa-sort"></i>
                                        </a>
                                    </th>
                                    <th class="text-right" style="width: 5rem">Action</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="uniform in uniformsList"
                                    :key="uniform.id"
                                >
                                    <td style="width: 3rem;">
                                        <div class="lines-block">
                                            <div class="line"></div>
                                            <div class="line"></div>
                                        </div>
                                    </td>

                                    <template v-if="activeUniform.id === uniform.id">
                                        <td>
                                            <input type="text" class="form-control mb-0 w-100" v-model="uniform.title">
                                        </td>
                                    </template>
                                    <template v-else>
                                        <td>
                                            <b>{{ uniform.title }}</b>
                                        </td>

                                    </template>
                                    <td class="text-right">
                                        <div class="action-block">

                                            <button class="edit-link" v-if="activeUniform.id === uniform.id">
                                                <img src="/img/svg/check-5.svg" alt="Save"
                                                     @click="saveUniform(uniform)">
                                            </button>

                                            <button class="edit-link" v-else>
                                                <img src="/img/svg/icons-pen.svg" alt="Edit"
                                                     @click="editUniform(uniform)">
                                            </button>

                                            <button
                                                v-show="activeUniform.id !== uniform.id"
                                                class="delete-link"
                                                @click="showDeleteModal(uniform.id)"
                                            ><img src="/img/svg/on.svg" alt="delete">
                                            </button>

                                            <ActionModal confirm-text="Yes" reject-text="No"
                                                         :modalId="getModalId(uniform.id)"
                                                         @confirm="deleteUniform(uniform.id)">
                                                <template #body>
                                                    <div class="text-center mb-4">
                                                        <h4>
                                                            Are you sure you want <br> to delete this item?
                                                        </h4>
                                                    </div>
                                                </template>
                                            </ActionModal>
                                        </div>
                                    </td>
                                </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>
                    <Pagination
                        :currentPage="pagination.current_page"
                        :lastPage="pagination.last_page"
                        @changeItemsPerPage="changeItemsPerPage"
                        @changePage="changePage"/>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import UniformsService from "./service/UniformsService";
import AddNewItemModal from "../../../../../resources/js/components/AddNewItemModal.vue";
import ActionModal from "../../../../../resources/js/components/ActionModal.vue";
import Pagination from "../../../../../resources/js/components/Pagination.vue";
import {createDebouncedFunction} from "../../../../../resources/js/plugins/debounce";
import _ from "lodash";

export default {
    name: 'UniformsList',
    props: {
        isAvailableForView: Boolean,
    },
    components: {
        Pagination,
        ActionModal,
        AddNewItemModal
    },
    data() {
        return {
            activeUniform: {},
            uniformsList: [],
            loading: true,
            filters: {
                search: '',
                sortBy: 'title',
                sortDir: 'asc',
                page: 1,
            },
            pagination: {
                current_page: 1,
                last_page: 1,
                perPage: 10
            },
        }
    },
    methods: {
        delayedSearch: _.debounce(function () {
            this.getUniformsList()
        }, 500),
        async addNewUniform(text) {
            if (!text || text.trim() === '') {
                this.$showErrorMessage('Please enter the uniform title');
            } else {
                try {
                    const response = await UniformsService.addNewUniformItem(text);
                    this.uniformsList.push(response);
                    await this.getUniformsList();
                    $('#uniform-modal').modal('hide');
                    this.$showSuccessMessage('New uniform was added')
                } catch (error) {
                    this.$showErrorMessage('The uniform was not added. Server error');
                }
            }
        },
        changePage(newPage) {
            this.filters.page = newPage
            this.getUniformsList(this.filters)
        },
        changeItemsPerPage(newItemsPerPage) {
            this.filters.perPage = newItemsPerPage;
            this.getUniformsList(this.filters)
        },
        changeSortList(field) {
            if (this.filters.sortBy === field) {
                this.filters.sortDir = this.filters.sortDir === 'asc' ? 'desc' : 'asc';
            }
            this.filters.sortBy = field

            this.getUniformsList()
        },
        async deleteUniform(id) {
            this.$showLoadingMessage();
            this.uniformsList = this.uniformsList.filter((uniform) => uniform.id !== id)
            try {
                this.$showSuccessMessageDelete();
                await UniformsService.delete(id)
            } catch (error) {
                this.$showErrorMessage('The uniform item was not deleted. Server error');
            }
        },
        editUniform(uniform) {
            this.activeUniform = uniform
        },
        getModalId(uniformId) {
            return `modalId-${uniformId}`
        },
        async getUniformsList() {
            try {
                const {data: uniforms} = await UniformsService.getUniformsList(this.filters)
                this.uniformsList = uniforms.data.data
                this.pagination.current_page = uniforms.data.current_page
                this.pagination.last_page = uniforms.data.last_page
                this.loading = false
            } catch (e) {
                this.$showErrorMessage();
            }
        },
        async saveUniform(uniform) {
            if (!uniform.title || uniform.title.trim() === '') {
                this.$showErrorMessage('Please enter the uniform title');
            } else {
                try {
                    const {data: updatedUniform} = await UniformsService.updateUniformItem(uniform.id, uniform.title);
                    this.activeUniform = updatedUniform
                    this.$showSuccessMessage('The uniform item was updated!')

                } catch (e) {
                    this.$showErrorMessage('The uniform item was not updated. Please try again');
                }
            }
        },
        showModal() {
            $(`#uniform-modal`).modal()
        },
        showDeleteModal(id) {
            $(`#modalId-${id}`).modal()
        },
        handleSearch() {
            this.filters.page = 1
            this.delayedSearch();
        },
    },
    mounted() {
        this.getUniformsList();
    }

}

</script>


<style scoped>

</style>
